import { ColumnGroup } from 'rsuite-table';

export default ColumnGroup;
